export const SERVICES = [
  {
    id: "live-chat",
    n: "01",
    title: "Live Chat Support",
    desc: "Always-on conversational support that resolves customer queries in real time across web, app and social channels.",
    points: ["24/7 multilingual coverage", "Sub-30s response SLAs", "CRM & helpdesk integration"],
    icon: "MessageSquare",
  },
  {
    id: "virtual-assistant",
    n: "02",
    title: "Virtual Assistant",
    desc: "Dedicated remote professionals who manage calendars, inboxes, research and the recurring work that slows your team down.",
    points: ["Appointment setting", "Data entry", "CRM updates", "Document preparation", "Report management"],
    icon: "Headset",
  },
  {
    id: "customer-service",
    n: "03",
    title: "Customer Service",
    desc: "Omnichannel voice, email and ticket support engineered to protect retention and lift your CSAT scores.",
    points: ["Voice, email & ticketing", "Escalation workflows", "Quality assurance scoring"],
    icon: "LifeBuoy",
  },
  {
    id: "lead-generation",
    n: "04",
    title: "Lead Generation",
    desc: "Targeted outbound and inbound prospecting that fills your pipeline with qualified, sales-ready opportunities.",
    points: ["Outbound dialing", "Live transfer", "Email marketing", "Warm & cold outreach campaigns"],
    icon: "Target",
  },
  {
    id: "admin-support",
    n: "05",
    title: "Admin Support",
    desc: "Back-office operations handled end-to-end so your core team stays focused on growth, not paperwork.",
    points: ["Document processing", "Order & invoice handling", "Process documentation"],
    icon: "ClipboardList",
  },
];

export const METRICS = [
  { value: "99.9%", label: "Uptime SLA" },
  { value: "850+", label: "Trained Agents" },
  { value: "120+", label: "Global Clients" },
];

export const TESTIMONIALS = [
  {
    quote:
      "NovaWorks rebuilt our entire support operation in six weeks. Response times dropped 70% and our CSAT has never been higher.",
    name: "Marcus Reyes — VP Operations",
    company: "Lumen Retail",
  },
  {
    quote:
      "Their lead generation team consistently books more qualified meetings than the agency we replaced — at a fraction of the cost.",
    name: "Priya N. — Head of Growth",
    company: "Vantage SaaS",
  },
  {
    quote:
      "The virtual assistants feel like part of our in-house team. Reliable, sharp, and genuinely invested in our outcomes.",
    name: "Daniel Cho — Founder",
    company: "Northbeam Studio",
  },
];
